import * as React from "react";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { DpcQuestionText, DpcWarningText } from "../Resource/Contents";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
interface IDPCQuestionProps extends IProcessComponentProps {
}

interface IDPCQuestionState {
    showDpcWarningMessage: boolean;
}

export class DPCQuestion extends ProcessComponent<IDPCQuestionProps, IDPCQuestionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            showDpcWarningMessage: false
        };
    }

    private onProductChange(changes, product, index) {
        for (const key in changes) {
            product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = product;
        this.props.onChange({ SelectedProducts: data });
    }

    private renderWarningMessage() {
        return (
            <Lightbox
                unclosable={true}
                noOverlay={false}
                noAutofocus={true}
                cssWrapper="is-default-lightbox"
                title="Disqualifying pension credit"
                contentCssCustom="pt-20"
                show={this.state.showDpcWarningMessage} 
                onClose={() => this.setState({ showDpcWarningMessage: false })
                }           >
                    <p>{DpcWarningText}</p>
                    <button
                        className="btn primary"
                        onClick={() => this.setState({ showDpcWarningMessage: false })}
                    >
                        OK
                    </button>
            </Lightbox>
        );
    }
    
    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.Npr);
        return (
            <>
                {
                    <RadiosEditor
                        cssWrapper="radio-group rg-inline rg-150 mb-23"
                        selected={data.SelectedProducts[productIndex]?.IsDisqualifyingPensionCredits}
                        options={[true, false]}
                        label={DpcQuestionText}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) =>{
                            this.onProductChange({ IsDisqualifyingPensionCredits: v }, data.SelectedProducts[productIndex], productIndex)
                            this.setState({ showDpcWarningMessage: v })
                        }}
                        required="Please select"
                    />
                }
                {this.state.showDpcWarningMessage && this.renderWarningMessage()}
            </>
        );
    }
}
